import Vue from 'vue';
import Vuex from 'vuex'

//import routes from './routes'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex);

import {Guitar} from '@shared/classes/guitar'
import {Sound} from '@shared/classes/sound'
import {SoundTrack} from "@shared//classes/soundTrack";

/*

STORE CON FUNZIONALITA' COMUNI

 */


function createSoundTrackFromActiveFrets(matrix) {
    // Create an array to store items with (x, y, value) and boolean
    const items = [];

    // Loop through the matrix and extract items with a boolean value of true
    for (let s = 0; s < matrix.length; s++) {
        for (let f = 0; f < matrix[s].length; f++) {

            if (matrix[s][f].show === true) {
                items.push({
                    'string': s, 'fret': f, 'midi': matrix[s][f].midi
                });
            }
        }
    }

    // Sort the items by integer value
    items.sort((a, b) => a.midi - b.midi);

    // soundTrack si aspetta copie string (range 1-6) e fret
    let buffer = []
    for (let i = 0; i < items.length; i++) {
        buffer.push([items[i]['string'] + 1, items[i]['fret']])
    }

    console.log(buffer);

    return buffer;
}


/* Vuex store */
const baseStore = new Vuex.Store({
    state: {
        guitar: new Guitar(), soundManager: new Sound(), soundTrack: null, enableUserInput: false


    }, getters: {
        soundLoaded(state) {
            return state.soundManager.getSoundLoaded();
        }
    },

    plugins: [createPersistedState({
        paths: []
    })],


    mutations: {

        // eslint-disable-next-line no-unused-vars
        initialiseStore(state) {
            state.soundTrack = new SoundTrack(state.guitar, state.soundManager)
        },

        /* GUITAR */
        toggleFret(state, params) {
            state.guitar.toggleFret(params.string, params.fret);

            // se ho abilitato modifiche da utente
            if (state.enableUserInput === true) {
                let track = createSoundTrackFromActiveFrets(state.guitar.matrix);
                state.soundTrack.setTrack(track);
            }
        },

        setGuitarRootStep(state, params) {
            state.guitar.setRootStep(params.rootStep)
        },


        startPlayback(state) {
            state.soundTrack.startPlayback();
        },

        stopPlayback(state) {
            state.soundTrack.stopPlayback();
        },

        rewind(state) {
            state.soundTrack.rewind();
        },

        setEnableUserInput(state, params) {
            state.enableUserInput = params.value;
        }


    },

    actions: {
        setBpm(context, params) {

            let bpm = params.bpm;
            if (bpm > 300) {
                bpm = 300
            }

            if (bpm < 30) {
                bpm = 30
            }

            context.state.soundTrack.setBpm(bpm);

        },

    }
})

export default baseStore;
